/**
 * Traduções nossas — tela de Relatórios: seletor de período, opções dos
 * cartões e os nomes dos cartões que o painel cria sozinho.
 *
 * A chave é a frase em inglês, byte a byte como está em `locale/en.json`
 * (ou, no caso dos nomes de cartão, em `loot-core/src/shared/dashboard.ts` —
 * ver `nomeDeWidget.ts` para o porquê).
 */
export const relatorios: Record<string, string> = {
  // --- Nomes dos cartões padrão do painel ---
  'Total Income (YTD)': 'Receita do ano',
  'Total Expenses (YTD)': 'Despesas do ano',
  'Avg Per Month': 'Média por mês',
  'Avg Per Transaction': 'Média por lançamento',
  'This Month': 'Este mês',
  'Budget Overview': 'Visão do orçamento',
  '3-Month Average': 'Média de 3 meses',
  'Transaction Calendar': 'Calendário de lançamentos',
  'Recent Net Worth Change': 'Variação recente do patrimônio',

  // --- Seletor de período ---
  'Select by': 'Selecionar por',
  'Quick select': 'Atalhos',
  'Date range': 'Período',
  'Last 30 days': 'Últimos 30 dias',
  'Next 3 months': 'Próximos 3 meses',
  'Next 6 months': 'Próximos 6 meses',
  'Next year': 'Próximo ano',
  YTD: 'No ano',
  All: 'Tudo',

  // --- Opções dos cartões ---
  'Show trend lines': 'Mostrar linhas de tendência',
  'Show categories': 'Mostrar categorias',
  'Show title:': 'Mostrar título:',
  'Show up to {{n}}': 'Mostrar até {{n}}',
  'Group accounts in Spent view': 'Agrupar contas na visão de gastos',
  'Show transfers in Spent view': 'Mostrar transferências na visão de gastos',
  'Income category': 'Categoria de receita',
  'Reset layers': 'Restaurar as camadas',
  'Export budget analysis': 'Exportar a análise do orçamento',
  'Export as CSV': 'Exportar como CSV',
  'Monte Carlo analysis': 'Análise Monte Carlo',
  'Spent Average MTD ({{rangeLabel}}):':
    'Média gasta no mês até hoje ({{rangeLabel}}):',
  'Spent Average ({{rangeLabel}}):': 'Média gasta ({{rangeLabel}}):',
};
